import { render, staticRenderFns } from "./CheckListItemCategoryTab.vue?vue&type=template&id=4c5ff564&scoped=true&"
import script from "./CheckListItemCategoryTab.vue?vue&type=script&lang=js&"
export * from "./CheckListItemCategoryTab.vue?vue&type=script&lang=js&"
import style0 from "./CheckListItemCategoryTab.vue?vue&type=style&index=0&id=4c5ff564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5ff564",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VList,VListItem,VListItemTitle,VMenu})
